// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RedeemDialog-module-container-EvwI9{display:flex;flex-wrap:wrap;justify-content:space-between;margin-bottom:10px}.RedeemDialog-module-title-2dOqw{text-align:center;flex:0 0 100%;margin-bottom:30px}.RedeemDialog-module-messageBox-3hRnC{margin-bottom:16px}.RedeemDialog-module-imageHolder-2ZCui{width:100%;margin-bottom:42px}@media(min-width: 960px){.RedeemDialog-module-imageHolder-2ZCui{width:45%;margin-bottom:0}}.RedeemDialog-module-imageHolder-2ZCui img{min-width:286px;min-height:150px;width:100%}.RedeemDialog-module-bottomText-3dqwK{display:flex;justify-content:center;width:100%;margin-top:16px}", ""]);
// Exports
exports.locals = {
	"container": "RedeemDialog-module-container-EvwI9",
	"title": "RedeemDialog-module-title-2dOqw",
	"messageBox": "RedeemDialog-module-messageBox-3hRnC",
	"imageHolder": "RedeemDialog-module-imageHolder-2ZCui",
	"bottomText": "RedeemDialog-module-bottomText-3dqwK"
};
module.exports = exports;
